const MAX_SOURCE_REQUEST_ID_CHARS = 255;

/** The characters a source id may hold: printable ASCII, space through tilde. */
export const PRINTABLE_ASCII = /^[\x20-\x7e]+$/;

function isPrintableAscii(value: string): boolean {
  return PRINTABLE_ASCII.test(value);
}

function sourceRequestId(literal: string): string {
  if (isPrintableAscii(literal) && literal.length <= MAX_SOURCE_REQUEST_ID_CHARS) {
    return literal;
  }
  throw new Error(
    `source identifier must be printable ASCII of at most ${MAX_SOURCE_REQUEST_ID_CHARS} characters`,
  );
}

export const sourceIds = {
  creditRefresh: (claimRequestId: string) => sourceRequestId(claimRequestId),
  signupGrant: (signupEventId: string) => sourceRequestId(signupEventId),
  openingBalance: (importBatchId: string, userId: string) =>
    sourceRequestId(`${importBatchId}:${userId}`),
  /** A Checkout Session id, or the id of a one-off invoice charged to a saved card. */
  purchase: (stripePurchaseId: string) => sourceRequestId(stripePurchaseId),
  /** Cycle 0 is the invoice id. Each re-grant after a failed payment is `{invoiceId}:{cycle}`. */
  subscription: (stripeInvoiceId: string, cycle = 0) =>
    sourceRequestId(cycle === 0 ? stripeInvoiceId : `${stripeInvoiceId}:${cycle}`),
  /**
   * An App Store transaction: a pack, or one month of a subscription. The `app_store:` prefix is
   * what the ledger reads as the App Store source system.
   */
  appStoreTransaction: (transactionId: string) => sourceRequestId(`app_store:${transactionId}`),
  compensation: (program: string, grantRequestId: string) =>
    sourceRequestId(`${program}:${grantRequestId}`),
  otherReward: (program: string, grantRequestId: string) =>
    sourceRequestId(`${program}:${grantRequestId}`),
  supportAdjustment: (adjustmentRequestId: string) => sourceRequestId(adjustmentRequestId),
  closure: (closureRequestId: string) => sourceRequestId(closureRequestId),
} as const;
